import { useCallback, useMemo } from 'react';
import { useGetCommunityBlockedUserIdsQuery } from 'generated/graphql';
import { CommunityId } from '../model/community.types';
import { AuthorId } from '../model/post.types';

export const useIsAuthorBlocked = (communityId: CommunityId) => {
  const { data } = useGetCommunityBlockedUserIdsQuery({
    variables: { communityId },
    fetchPolicy: 'cache-and-network',
  });

  const blockedIds = useMemo(
    () => new Set((data?.blockedUsers ?? []).map((user) => user.id)),
    [data],
  );

  return useCallback(
    (authorId: AuthorId) => blockedIds.has(authorId),
    [blockedIds],
  );
};
